export default "__VITE_ASSET__BkLKVr9S__"